<template lang='pug'>
  section.section
    table.table
      thead
        tr
          th オプション
          th
      tbody
        tr
          th キャッシュを削除
          td
            button(@click="clearCache" class='button' type='button') 実行
</template>

<script>
  import CacheDispatcher from 'mixins/cache_dispatcher'

  export default {
    mixins: [CacheDispatcher],
    name: 'others-table',
    methods: {
      clearCache() {
        this.expiresCache()
        this.$toast.open({
          message: "キャッシュデータが削除されました",
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
    }
  }
</script>